// Material
import { Box, Divider, ListItemButton, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

const StyledListItemButton = styled(ListItemButton)`
  width: 100%;
  min-height: 66px;

  margin: 0;
  padding: 8px 15px;
  background-color: transparent;

  outline: none;
  justify-content: flex-start;
  text-align: inherit;
`

const StyledDivider = styled(Divider)`
  margin-right: 15px;
  &:last-child {
    display: none;
  }
`

interface Props {
  value: string
  label: string
  placeholder?: string
  onClick: () => unknown
}

// TODO: [refactor] rename props to more meaningful names
// FIXME: maybe list item can be a better option for lists
// FIXME: dir="auto" for now in description but it can be forced to some based on body tag
export function ProfileInfoItem({ value, label, placeholder, onClick }: Props) {
  return (
    <>
      <StyledListItemButton onClick={onClick}>
        <Box>
          <Typography
            gutterBottom
            variant="caption1"
            component="div"
            color="secondary.main"
            sx={{ marginBottom: '5px', textAlign: 'right' }}
          >
            {label}
          </Typography>
          <Typography
            dir="auto"
            variant="body2"
            color={value ? 'semiBlack' : 'semiLightGray'}
          >
            {value || placeholder}
          </Typography>
        </Box>
      </StyledListItemButton>
      <StyledDivider />
    </>
  )
}

ProfileInfoItem.defaultProps = {
  placeholder: '',
}
